import React from 'react';
import { HashDialog } from '../../../../shared/components/dialog/HashDialog';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { BookingDetailsDialog } from './BookingDetailsDialog';

export const PARKING_BOOKING_DETAILS_HASH_PATTERN = '#booking/:reference';

export function getBookingDetailsHash(reference: string) {
	return PARKING_BOOKING_DETAILS_HASH_PATTERN.replace(':reference', reference);
}

export interface IBookingDetailsDialogHashMatches {
	reference: string;
}

export const BookingDetailsDialogRoute = () => {
	const { t } = useTranslation();

	return (
		<HashDialog
			hash={PARKING_BOOKING_DETAILS_HASH_PATTERN}
			ariaLabel={t('parking_booking_details_header')}
		>
			<BookingDetailsDialog />
		</HashDialog>
	);
};
